import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { useLang } from "../i18n";

export const DEMO_MAILTO = "mailto:info@riseyourlife.it?subject=Presentazione%20RISE%20your%20LIFE";
const PRIMARY = "rounded-full bg-[#3F6E85] hover:bg-[#2B4A59] text-white px-8 h-12 text-base gap-2 hover:-translate-y-0.5 transition-transform";

export function AudienceToggle({ value, onChange }) {
  const { t } = useLang();
  const pill = (v, label) => (
    <button type="button" onClick={() => onChange(v)} aria-pressed={value === v} data-testid={`audience-${v}`}
      className={`h-10 px-5 rounded-full text-sm font-medium transition-colors ${value === v ? "bg-[#3F6E85] text-white" : "bg-transparent text-[#2B4A59] border border-stone-200 hover:border-stone-300"}`}>
      {label}
    </button>
  );
  return (
    <div className="flex justify-center lg:justify-start gap-2 mb-6" role="group" data-testid="audience-toggle">
      {pill("persone", t("aud_personal"))}
      {pill("aziende", t("aud_business"))}
    </div>
  );
}

export function PrimaryCta({ biz, testid }) {
  const { t } = useLang();
  if (biz) {
    return (
      <a href={DEMO_MAILTO} data-testid={testid}>
        <Button className={PRIMARY}>{t("cta_book_demo")} <ArrowRight className="w-4 h-4" /></Button>
      </a>
    );
  }
  return (
    <Link to="/register" data-testid={testid}>
      <Button className={PRIMARY}>{t("cta_free")} <ArrowRight className="w-4 h-4" /></Button>
    </Link>
  );
}

export function StepsSection({ title, steps, testid }) {
  return (
    <section className="bg-[#3F6E85] text-[#FDFBF7]" data-testid={testid}>
      <div className="max-w-[720px] mx-auto px-6 py-20">
        <h2 className="font-serif text-3xl sm:text-4xl tracking-tight mb-10">{title}</h2>
        <div className="space-y-8">
          {steps.map(([title_, desc], i) => (
            <div key={i} className="flex gap-5">
              <span className="shrink-0 w-10 h-10 rounded-full border border-[#E08A3C] text-[#FDFBF7] flex items-center justify-center font-serif text-xl">{i + 1}</span>
              <div>
                <p className="text-lg font-semibold">{title_}</p>
                {desc && <p className="text-[#c9d3cd]">{desc}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function PrivacyFaq() {
  const { t } = useLang();
  return (
    <section className="max-w-[720px] mx-auto px-6 py-20" data-testid="privacy-faq">
      <h2 className="font-serif text-3xl sm:text-4xl tracking-tight text-[#2B4A59] mb-8">{t("faq_title")}</h2>
      <Accordion type="single" collapsible className="mb-12">
        {[1, 2, 3].map((n) => (
          <AccordionItem key={n} value={`q${n}`} data-testid={`faq-item-${n}`}>
            <AccordionTrigger className="text-left text-base font-semibold text-[#2B4A59]" data-testid={`faq-trigger-${n}`}>{t(`faq_q${n}`)}</AccordionTrigger>
            <AccordionContent className="text-base text-[#3a3a3a] leading-relaxed">{t(`faq_a${n}`)}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="flex justify-center"><PrimaryCta biz testid="biz-bottom-cta" /></div>
    </section>
  );
}
